const INTERNAL_LINK_BY_PO_PREFIX = '?#po'; // Link to another SpineEntry via SpineEntry.playOrder
const INTERNAL_LINK_BY_ID_PREFIX = '?#sp'; // Link to another SpineEntry via SpineEntry.id, older format

const isDataUri = (linkHref) => {
  const pattern = new RegExp('data:');
  return pattern.test(linkHref);
};

const isExternalLink = (linkHref) => {
  return (
    !isInternalLinkById(linkHref) &&
    !isInternalLinkByPlayOrder(linkHref) &&
    !isInternalHashtag(linkHref)
  );
};

const isInternalLinkById = (linkHref) => {
  return linkHref.startsWith(INTERNAL_LINK_BY_ID_PREFIX);
};

const isInternalLinkByPlayOrder = (linkHref) => {
  return linkHref.startsWith(INTERNAL_LINK_BY_PO_PREFIX);
};

const isInternalHashtag = (linkHref) => {
  // '#example'
  const split = linkHref && linkHref.split('#');
  return split && !split[0] && split[1];
};

const parseInternalLinkByPlayOrder = (linkHref) => {
  // split from linkHref of ?#po(playOrder):(element) to [playOrdre, element]
  const hrefParts = linkHref.split(INTERNAL_LINK_BY_PO_PREFIX)[1].split(':');
  const spinePlayOrder = hrefParts[0];
  const fragmentId = hrefParts[1];

  return { spinePlayOrder, fragmentId };
};

const parseInternalLinkById = (linkHref) => {
  // split from ?#sp(id):(element) to [id, element]
  // older format
  const hrefParts = linkHref.split(INTERNAL_LINK_BY_ID_PREFIX)[1].split(':');
  const spineId = hrefParts[0];
  const fragmentId = hrefParts[1];

  return { spineId, fragmentId };
};

const linkUtils = {
  isDataUri,
  isExternalLink,
  isInternalLinkById,
  isInternalLinkByPlayOrder,
  isInternalHashtag,
  parseInternalLinkByPlayOrder,
  parseInternalLinkById,
};

export default linkUtils;
